import React from "react";

export default function BadgeUnlockModal({ newBadge, setNewBadge }) {
  if (!newBadge) return null;

  return (
    <div style={{
      position: "fixed",
      inset: 0,
      background: "rgba(26,18,8,0.75)",
      backdropFilter: "blur(8px)",
      WebkitBackdropFilter: "blur(8px)",
      zIndex: 1000,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      padding: "1rem",
    }}>
      <div style={{
        background: "linear-gradient(135deg, #1A1208 0%, #2D1F0E 100%)",
        border: "2px solid #C8922A",
        borderRadius: "20px",
        padding: "2.5rem 2rem",
        maxWidth: "420px",
        width: "100%",
        textAlign: "center",
        boxShadow: "0 20px 50px rgba(200,146,42,0.3)",
        color: "#fff",
        position: "relative",
        animation: "fadeUp 0.4s ease both"
      }}>
        {/* Sparkles / Gold crown */}
        <div style={{
          fontSize: "3.5rem",
          marginBottom: "1rem",
          animation: "bounce 2s infinite ease-in-out",
        }}>
          {newBadge.icon}
        </div>

        <div style={{
          fontSize: "0.75rem",
          color: "#C8922A",
          textTransform: "uppercase",
          letterSpacing: "0.15em",
          fontWeight: 700,
          fontFamily: "'Outfit', sans-serif",
          marginBottom: "0.5rem",
        }}>
          ✦ Achievement Unlocked ✦
        </div>

        <h3 style={{
          fontFamily: "'Cormorant Garamond', serif",
          fontSize: "1.8rem",
          fontWeight: 400,
          color: "#fff",
          margin: "0 0 1rem 0",
        }}>
          {newBadge.title}
        </h3>

        <p style={{
          color: "rgba(255,255,255,0.7)",
          fontSize: "0.9rem",
          lineHeight: 1.6,
          fontFamily: "'Outfit', sans-serif",
          marginBottom: "2rem",
        }}>
          {newBadge.description}
        </p>

        <button
          onClick={() => setNewBadge(null)}
          style={{
            background: "linear-gradient(135deg, #C8922A, #a87922)",
            color: "#1A1208",
            border: "none",
            borderRadius: "8px",
            padding: "12px 28px",
            fontSize: "0.9rem",
            fontWeight: 700,
            cursor: "pointer",
            fontFamily: "'Outfit', sans-serif",
            transition: "transform 0.15s, box-shadow 0.2s",
            boxShadow: "0 4px 14px rgba(200,146,42,0.4)",
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.transform = "scale(1.03)";
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.transform = "none";
          }}
        >
          Continue Reading
        </button>
      </div>
    </div>
  );
}
